import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxMultiSelectComponent } from './mx.multi-select.component';

export const COMPONENTS: any[] = [MxMultiSelectComponent];

@NgModule({
  imports: [CommonModule, PrimengModule, FormsModule, I18NextModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxMultiSelectModule {}
